import { IndirectTaxClientTask } from '../types';
import { IndirectTaxClientTaskTable } from './IndirectTaxClientTaskTable';
import { IndirectTaxTaskAccordion } from './IndirectTaxTaskAccordion';

interface IndirectTaxClientTaskBarProps {
  tasks: IndirectTaxClientTask[];
  corporationId: number;
  defaultOpen?: boolean;
}

export function IndirectTaxClientTaskBar({
  tasks,
  corporationId,
  defaultOpen,
}: IndirectTaxClientTaskBarProps) {
  if (tasks.length === 0) return null;

  return (
    <IndirectTaxTaskAccordion
      pendingCount={tasks.length}
      totalCount={tasks.length}
      defaultOpen={defaultOpen}
    >
      <IndirectTaxClientTaskTable
        tasks={tasks}
        corporationId={corporationId}
      />
    </IndirectTaxTaskAccordion>
  );
}
